"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _unzip = _interopRequireDefault(require("./unzip.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Zip together multiple lists into a single array -- elements that share
// an index go together.
var _default = exports.default = (0, _restArguments.default)(_unzip.default);